module.exports = __webpack_public_path__ + "img/document.e486b482.svg";